import algoliasearch from 'algoliasearch'

import { IS_DEV } from '../constant'

const prefix = IS_DEV ? 'dev_' : 'prod_'

export const client = algoliasearch('HO3CWI48E4', '6dce1748af068671c600d6d2865a1a80')

export const user = client.initIndex(`${prefix}USERS`)
export const clients = client.initIndex(`${prefix}CLIENTS`)
export const userFolio = client.initIndex(`${prefix}USER_FOLIOS`)
export const casting = client.initIndex(`${prefix}CASTINGS`)
export const castingProfile = client.initIndex(`${prefix}CASTING_PROFILES`)


export const getAll = async (index, query = '', options = {}) => {
  const {
    sort,
    onlyItems,
    ...rest
  } = options

  if (sort) {
    index = client.initIndex(`${index.indexName}_${sort}`)
  }

  const result = await index.search(query, {
    hitsPerPage: 20,
    ...rest,
  })

  return onlyItems ? result.hits : result
}

export const browse = async (index, query = '', options = {}) => {
  const firstResult = await getAll(index, query, options)
  const iteration = firstResult.nbPages
  let result = firstResult.hits

  for (let i = 1; i < iteration; i++) {
    const currentResult = await getAll(index, query, {
      ...options,
      page: i,
    })

    result = result.concat(currentResult.hits)
  }

  return result
}

export const browseIds = async (index, query, filters = {}) => {
  const items = await browse(index, query, filters)

  return items.map(item => item.objectID)
}

export const getById = async (index, objectID, options = {}) => {
  const result = await index.search('', {
    filters: `objectID:${objectID}`,
    ...options,
  })

  return result.hits[0]
}


export const getUserById = async (userId, options = {}) => {
  const result = await getById(user, userId, options)
  const folios = await getAll(userFolio, '', {
    hitsPerPage: 500,
    filters: `userId:${userId}`,
  })

  return {
    ...result,
    folios: folios.hits,
  }
}

export const getClientById = async (clientId, options = {}) => {
  const result = await getById(clients, clientId, options)
  const castings = await getAll(casting, '', {
    hitsPerPage: 500,
    filters: `email:${result.email}`,
  })

  result.castings = castings.hits
  return result
}


export const getCastingById = async (castingId, options = {}) => {
  const result = await getById(casting, castingId, options)
  const profiles = await getAll(castingProfile, '', {
    filters: `castingId:${castingId}`,
    hitsPerPage: 500
  })
  return {
    ...result,
    profiles: await Promise.all(profiles.hits.map(async (hit) => {
      if (hit.is_manual) {
        return hit
      }

      const user = await getUserById(hit.profileId)

      return {
        ...user,
        ...hit,
      }
    })),
  }
}


export default client
